/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type VcdsDisconnectedDeploymentStateEnum = 'READY' | 'DELETED';

export const VcdsDisconnectedDeploymentStateEnum = {

    READY: 'READY' as VcdsDisconnectedDeploymentStateEnum,

    DELETED: 'DELETED' as VcdsDisconnectedDeploymentStateEnum
};

